import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-download-snackbar',
  template: `
    <div class="snackbar-container">
      <div class="snackbar-header">
        <div class="message-text">
          <span class="icon">⬇</span>
          <span class="filename" [title]="data.filename">"{{ data.filename }}"</span>
          <span class="progress-text"> downloaded {{ data.downloadedMB$ | async }} MB</span>
        </div>
        <button mat-button class="hide-btn" (click)="snackBarRef.dismiss()">Hide</button>
      </div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  `,
  styles: [`
    .snackbar-container {
      display: flex;
      flex-direction: column;
      gap: 12px;
      width: 100%;
      padding-top: 4px;
    }
    .snackbar-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 8px; /* Spacing between text and button */
    }
    .message-text {
      display: flex;
      align-items: center;
      font-size: 14px;
      overflow: hidden;
      flex-grow: 1;
    }
    .icon {
      flex-shrink: 0;
    }
    .filename {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin: 0 4px;
      font-weight: 500;
    }
    .progress-text {
      white-space: nowrap;
      flex-shrink: 0; /* Prevents the MB part from EVER being cut off */
    }
    .hide-btn {
      color: #ffffff; /* Fixes the dark blue text on blue background */
      flex-shrink: 0;
      min-width: auto;
      padding: 0 8px;
    }
  `]
})
export class DownloadSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: {
      filename: string;
      downloadedMB$: BehaviorSubject<string>;
    },
    public snackBarRef: MatSnackBarRef<DownloadSnackbarComponent>
  ) {}
}
